<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
import code from '@/services/api/code.api';
export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fas fa-chart-pie',
      title: 'Informe de Evaluaciones Rechazadas',
      routes: ['Informes', 'Informe de Evaluaciones Rechazadas'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
        },
        filters: {
          academicYear: null,
          sie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          placeholder: 'Escriba Número de SIE',
          label: 'SIE',
          icon: 'fa fa-search orange-icon',
          value: this.model.search.filters.sie,
          leftIcon: true,
          type: 'text',
          class: 'col-md-3',
        },
      ];
    },
  },
  async mounted() {
    this.initFilters();
  },
  methods: {
    async initFilters() {
      await code.getSaee10FiltersAsync().then(({ data }) => {
        this.model.search.collections.academicYears = data.academicYears;
      });
      this.model.search.filters.academicYear = this.model.search.collections.academicYears[0];
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        this.process();
      }
    },
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      await ReportServices.getReport('rpt-rejectedevaluations', {
        academicYearId: this.model.search.filters.academicYear.id,
        studentSieId: this.model.search.filters.sie,
      }).then((res) => DocumentServices.Download(res.data));
    },
  },
};
</script>
